import { FC, memo } from 'react';
import styles from './spinner.module.css';

type SpinnerProps = {
  /** Spinner size, for example "50px" */
  size?: string;
  /** Spinner color, for example "#000" */
  color?: string;
};

export const Spinner: FC<SpinnerProps> = memo(
  ({ size = '40px', color = '#000' }) => {
    return (
      <div
        className={styles.spinner}
        style={{
          width: size,
          height: size,
          borderColor: `${color} ${color} ${color} transparent`,
        }}
      />
    );
  },
);

export default Spinner;
